import Layout from 'components/Layout';
import React, { useState } from 'react';
import { Nav, TabContent, TabPane } from 'reactstrap';


import { TabItem } from '../components/tabItem';
import MenuSetting from '../components/uuCafeMealntrol/MenuSettings';
import ZoneEditor from '../components/uuCafeMealntrol/ZoneEditor';
import ZoneSEOSetting from '../components/uuCafeMealntrol/ZoneSEOSetting';

const CafeMealIntroMenu = () => {
  const [currentTab, setCurrentTab] = useState(1);
  return (
    <Layout
      pageTitle="餐點介紹-咖啡專區"
      items={[
        { isActive: true, page_name: 'UUCafe' },
        { isActive: true, page_name: '餐點介紹-咖啡專區' },
      ]}
    >
      <Nav pills className="mb-2">
        <TabItem
          onClick={setCurrentTab}
          tab={1}
          text="咖啡選單"
          currentTab={currentTab}
        />
        <TabItem
          onClick={setCurrentTab}
          tab={2}
          text="咖啡頁面設定"
          currentTab={currentTab}
        />
        <TabItem
          onClick={setCurrentTab}
          tab={3}
          text="SEO設定"
          currentTab={currentTab}
        />
      </Nav>
      <TabContent activeTab={currentTab}>
        <TabPane tabId={1}>
          <MenuSetting />
        </TabPane>
        <TabPane tabId={2}>
          <ZoneEditor />
        </TabPane>
        <TabPane tabId={3}>
          <ZoneSEOSetting />
        </TabPane>
      </TabContent>
    </Layout>
  );
};

export default CafeMealIntroMenu;
